export default {
    methods: {
        postMessage() {
            this.checkLogin().then(() => {
                this.$EventBus.$emit('postMessage', this.info);
            });
        }
    }
};
